//data below should ideally correspond to data of usn 60425 
//on staging api call
//e.g. https://crossfire.z8games.com/rest/userprofile.json?usn=60425

export const USNNumber = 60425;

export const pageHeaderData = {"FAME_GRADE":null,"markLayer03":null,"EXP_TIER_DISPLAY_NAME":"Corporal","EXP_TIER_CATEGORY_ID":5,"markLayer01":null,"NICK":"CTM_00005804","REG_DATE":"2013/05/20 02:43:27.223","markLayer04":null,"marklayer02":null,"clanName":null,"EXP_TIER_SCORE_INI":3192,"EXP_TIER_SCORE_INI_NEXT":5016,"clanKey":null,"EXP":4670,"LEV":0,"EXP_TIER_SCORE_END":5015};

export const mainPageData = {
  dsProfilePINList: [
    {"hasIt":1,"PIN_ID":1,"ribbonID":23,"regDate":"2017/11/22 20:41:19.913","ribbonName":"Honorable Soldier","PIN_DISPLAY_NAME":"Honorable Soldier","PIN_ORDER":1},
    {"hasIt":1,"PIN_ID":2,"ribbonID":5,"regDate":"2018/11/22 20:41:19.913","ribbonName":"Veteran Soldier","PIN_DISPLAY_NAME":"Years of Service","PIN_ORDER":2},
    {"hasIt":0,"PIN_ID":2,"ribbonID":59,"regDate":null,"ribbonName":"Grizzled Veteran","PIN_DISPLAY_NAME":"Years of Service","PIN_ORDER":3},
    {"hasIt":0,"PIN_ID":2,"ribbonID":63,"regDate":null,"ribbonName":"3 Year Veteran","PIN_DISPLAY_NAME":"Years of Service","PIN_ORDER":4},
    {"hasIt":0,"PIN_ID":2,"ribbonID":64,"regDate":null,"ribbonName":"4 Year Veteran","PIN_DISPLAY_NAME":"Years of Service","PIN_ORDER":5},
    {"hasIt":0,"PIN_ID":2,"ribbonID":82,"regDate":null,"ribbonName":"5 Year Veteran","PIN_DISPLAY_NAME":"Years of Service","PIN_ORDER":6},
    {"hasIt":0,"PIN_ID":2,"ribbonID":65,"regDate":null,"ribbonName":"6 Year Veteran","PIN_DISPLAY_NAME":"Years of Service","PIN_ORDER":7},
    {"hasIt":0,"PIN_ID":2,"ribbonID":101,"regDate":null,"ribbonName":"7 Year Veteran","PIN_DISPLAY_NAME":"Years of Service","PIN_ORDER":8},
    {"hasIt":0,"PIN_ID":2,"ribbonID":91,"regDate":null,"ribbonName":"8 Year Veteran","PIN_DISPLAY_NAME":"Years of Service","PIN_ORDER":9},
    {"hasIt":0,"PIN_ID":2,"ribbonID":102,"regDate":null,"ribbonName":"9 Year Veteran","PIN_DISPLAY_NAME":"Years of Service","PIN_ORDER":10},
    {"hasIt":0,"PIN_ID":2,"ribbonID":103,"regDate":null,"ribbonName":"10 Year Veteran","PIN_DISPLAY_NAME":"Years of Service","PIN_ORDER":11},
    {"hasIt":0,"PIN_ID":3,"ribbonID":84,"regDate":null,"ribbonName":"Verified","PIN_DISPLAY_NAME":"Verified","PIN_ORDER":13},{"hasIt":0,"PIN_ID":4,"ribbonID":111,"regDate":null,"ribbonName":"Pro-Gamer","PIN_DISPLAY_NAME":"Pro-Gamer","PIN_ORDER":14},{"hasIt":0,"PIN_ID":5,"ribbonID":112,"regDate":null,"ribbonName":"Creator","PIN_DISPLAY_NAME":"Creator","PIN_ORDER":15},{"hasIt":0,"PIN_ID":6,"ribbonID":113,"regDate":null,"ribbonName":"Premium","PIN_DISPLAY_NAME":"Premium","PIN_ORDER":16},{"hasIt":1,"PIN_ID":7,"ribbonID":114,"regDate":"2019/07/18 13:53:54.100","ribbonName":"Weapon Collector","PIN_DISPLAY_NAME":"Collector","PIN_ORDER":17},{"hasIt":1,"PIN_ID":8,"ribbonID":115,"regDate":"2017/11/22 20:52:32.720","ribbonName":"VIP","PIN_DISPLAY_NAME":"VIP","PIN_ORDER":18}], 
    dsRibbonResult: [{"achivedDate":"2019/07/08 14:43:48.230","ribbonOption":"31","ribbonDescription":"<p>Your Kill/Death Ratio is above 2.0 (Dropping below 2.0 or K/D resets will remove it).</p>\r\n","ROWPOS":1,"imagePath":"https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/","imageFileName":"ribbon_0034.jpg","ribbonID":34,"ribbonName":"Clutch Killer","ribbonGroupSort":1,"ribbonType":"N","ribbonGroupName":"Normal","hasRibbon":1},{"achivedDate":"2015/04/14 12:07:51.250","ribbonOption":"1","ribbonDescription":"<p>You obtain it when you first create a character.</p>\r\n","ROWPOS":2,"imagePath":"https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/","imageFileName":"ribbon_0001.jpg","ribbonID":1,"ribbonName":"Creationism","ribbonGroupSort":1,"ribbonType":"N","ribbonGroupName":"Normal","hasRibbon":1},{"achivedDate":"2015/04/14 12:07:51.250","ribbonOption":"30","ribbonDescription":"<p>You've never been banned in-game for hacking or similar severe violations (accounts under investigation included).</p>\r\n","ROWPOS":3,"imagePath":"https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/","imageFileName":"ribbon_0023.jpg","ribbonID":23,"ribbonName":"Honorable Soldier","ribbonGroupSort":1,"ribbonType":"N","ribbonGroupName":"Normal","hasRibbon":1},{"achivedDate":null,"ribbonOption":"10","ribbonDescription":"<p>Your CrossFire character is older than 9 years.</p>\r\n","ROWPOS":4,"imagePath":"https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons//","imageFileName":"ribbon_0102.jpg","ribbonID":102,"ribbonName":"9 Year Veteran","ribbonGroupSort":1,"ribbonType":"N","ribbonGroupName":"Normal","hasRibbon":0},{"achivedDate":null,"ribbonOption":"100","ribbonDescription":"<p>You have either joined the Global Risk or the Black List side for the Rival Factions event. (discontinued)</p>\r\n","ROWPOS":5,"imagePath":"https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/","imageFileName":"ribbon_0011.jpg","ribbonID":11,"ribbonName":"Which Side are You On","ribbonGroupSort":2,"ribbonType":"S","ribbonGroupName":"Special","hasRibbon":0},{"achivedDate":null,"ribbonOption":"101","ribbonDescription":"<p>You successfully completed the Evolution 2.0 event.</p>\r\n","ROWPOS":6,"imagePath":"https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/","imageFileName":"ribbon_0081.jpg","ribbonID":81,"ribbonName":"CrossFire 2.0","ribbonGroupSort":2,"ribbonType":"S","ribbonGroupName":"Special","hasRibbon":0}],
    dsProfileEquippedWeapons:[{"USN":60425,"WEAPON_TYPE":"RIFLE_SLOT","ITEM_ID":"2010000301","ITEM_CODE":"C0003","SACK_SRL":1,"DISPLAY_NAME":"M700","INVENTORY_SRL":641778},{"USN":60425,"WEAPON_TYPE":"THROW_SLOT","ITEM_ID":"2010000701","ITEM_CODE":"C0007","SACK_SRL":0,"DISPLAY_NAME":"GRENADE","INVENTORY_SRL":641775},{"USN":60425,"WEAPON_TYPE":"THROW_SLOT","ITEM_ID":"2010000701","ITEM_CODE":"C0007","SACK_SRL":1,"DISPLAY_NAME":"GRENADE","INVENTORY_SRL":641776},{"USN":60425,"WEAPON_TYPE":"RIFLE_SLOT","ITEM_ID":"2010002501","ITEM_CODE":"C0025","SACK_SRL":0,"DISPLAY_NAME":"M16","INVENTORY_SRL":641777}],
    dsProfileDetails:[{"WIN_CNT":9,"RUSH_LEV":3,"SHOT_KILL":26,"CHAR_ITEM_CODE":"A0001","RIFLE_KILL":88,"HEADSHOT_KILL_CNT":170,"PLAY_CNT":192,"DEATH_CNT":137,"CHAR_KILL":0,"LOSE_CNT":113,"ENEMY_KILL_CNT":303,"SCOUTING_LEV":4,"HEAVY_KILL":48,"SNIPER_LEV":2,"DISPLAY_NAME":"SWAT","DRAW_KILL":3,"PISTOL_KILL":92,"ELITE_LEV":2,"SPECIAL_LEV":5,"USN":60425,"SHOTGUN_KILL":4,"SMG_KILL":2,"DEFAULT_CHAR_ITEM_ID":"1000000101","KNIFE_KILL":39,"DRAW_CNT":0}],
    dsCollectionTotal:[{"total_CNT":92,"completed_CNT":0}],
    dsCollectionResult:[{"user_Item_CNT":0,"collection_Name":"Ronove","description":"Ronove Collection","collection_Group_Name":"Group 1","reward_Type":"","nameCardImgURL":"https://z8games.akamaized.net/cfna/web/main/collections/nc/ronove_namecard.png","completed":"N","collection_ID":66,"collection_Group_ID":1,"ROWPOS":1,"nameCardText":"Ronove NC","completed_CNT":9,"reward_Desc":"","reward_Image":"300_169/C1418.png","total_Item_CNT":2,"collection_Image":"https://z8games.akamaized.net/cfna/web/main/collections/devilwing.png","status":1},{"user_Item_CNT":0,"collection_Name":"Ice Blade","description":"Ice Blade Collection","collection_Group_Name":"Group 1","reward_Type":"","nameCardImgURL":"https://z8games.akamaized.net/cfna/web/main/collections/nc/iceblade_namecard.png","completed":"N","collection_ID":99,"collection_Group_ID":1,"ROWPOS":2,"nameCardText":"[NC] Ice Blade","completed_CNT":5,"reward_Desc":"","reward_Image":"300_169/C1418.png","total_Item_CNT":2,"collection_Image":"https://z8games.akamaized.net/cfna/web/main/collections/iceblade.png","status":1},{"user_Item_CNT":0,"collection_Name":"Sun Wukong","description":"Modeled after the fabled Monkey King, these weapons are not only collectible, but mythical as well.","collection_Group_Name":"Group 1","reward_Type":"","nameCardImgURL":"https://z8games.akamaized.net/cfna/web/main/collections/nc/SunWuKong.png","completed":"N","collection_ID":35,"collection_Group_ID":1,"ROWPOS":3,"nameCardText":"Sun Wukong NC","completed_CNT":3,"reward_Desc":"","reward_Image":"300_169/C1418.png","total_Item_CNT":2,"collection_Image":"https://z8games.akamaized.net/cfna/web/main/collections/SunWuKong.png","status":1},{"user_Item_CNT":0,"collection_Name":"Khokhloma","description":"Khokhloma Collection","collection_Group_Name":"Group 1","reward_Type":"","nameCardImgURL":"https://z8games.akamaized.net/cfna/web/main/collections/nc/Khokhloma.png","completed":"N","collection_ID":46,"collection_Group_ID":1,"ROWPOS":4,"nameCardText":"Khokhloma NC","completed_CNT":3,"reward_Desc":"","reward_Image":"300_169/C1418.png","total_Item_CNT":2,"collection_Image":"https://z8games.akamaized.net/cfna/web/main/collections/Khokhloma.png","status":1},{"user_Item_CNT":0,"collection_Name":"Possessed Halloween","description":"Possessed Halloween Collection","collection_Group_Name":"Group 1","reward_Type":"Item","nameCardImgURL":"https://z8games.akamaized.net/cfna/web/main/collections/nc/possessed_namecard.png","completed":"N","collection_ID":78,"collection_Group_ID":1,"ROWPOS":5,"nameCardText":"Possessed Collection","completed_CNT":2,"reward_Desc":"Baby Ghost Grenade","reward_Image":"300_169/C1700.png","total_Item_CNT":2,"collection_Image":"https://z8games.akamaized.net/cfna/web/main/collections/WC0106.png","status":1},{"user_Item_CNT":0,"collection_Name":"Octane Camo","description":"This collection has been given an orange octane take on the classic camo designs.","collection_Group_Name":"Group 1","reward_Type":"","nameCardImgURL":"https://z8games.akamaized.net/cfna/web/main/collections/nc/OctaneCamo.png","completed":"N","collection_ID":32,"collection_Group_ID":1,"ROWPOS":6,"nameCardText":"Octane Camo NC","completed_CNT":1,"reward_Desc":"","reward_Image":"300_169/C1418.png","total_Item_CNT":2,"collection_Image":"https://z8games.akamaized.net/cfna/web/main/collections/OctaneCamo.png","status":1}],
    dsInventoryTotal:[{"CNT":3}],
    dsInventoryResult:[{"ROWPOS":1,"CNT":1,"ITEM_ID":"2010000301","ITEM_CODE":"C0003","ITEM_CATEGORY":1,"DISPLAY_NAME":"M700"},{"ROWPOS":2,"CNT":1,"ITEM_ID":"2010002501","ITEM_CODE":"C0025","ITEM_CATEGORY":1,"DISPLAY_NAME":"M16"},{"ROWPOS":3,"CNT":2,"ITEM_ID":"2010000701","ITEM_CODE":"C0007","ITEM_CATEGORY":1,"DISPLAY_NAME":"GRENADE"}],
    dsRibbonTotal:[{"ribbonCNT":96,"playerCNT":3}],
    dsRankedStatsResult: [
      {"PARTKEY_SEASON_NO":9,"MODE_NO_DESC":"TDM","TIER_GROUP_NAME":"Bronze","HEADSHOT":0,"MEDAL":6,"DEATH":0,"RANKING":3,"TIER_STAGE_ID":6,"MODE_NO":1,"MATCH_COUNT":18,"USN":61471,"TIER_GROUP_ID":1,"ROWPOS":1,"LOSE":17,"RANK_SCORE":761,"WIN":1,"KILL":0},
      {"PARTKEY_SEASON_NO":9,"MODE_NO_DESC":"SND","TIER_GROUP_NAME":"Bronze","HEADSHOT":1,"MEDAL":5,"DEATH":6,"RANKING":4,"TIER_STAGE_ID":5,"MODE_NO":2,"MATCH_COUNT":23,"USN":61471,"TIER_GROUP_ID":1,"ROWPOS":2,"LOSE":22,"RANK_SCORE":661,"WIN":1,"KILL":2},
      {"PARTKEY_SEASON_NO":8,"MODE_NO_DESC":"TDM","TIER_GROUP_NAME":"Silver","HEADSHOT":165,"MEDAL":9,"DEATH":0,"RANKING":2,"TIER_STAGE_ID":5,"MODE_NO":1,"MATCH_COUNT":0,"USN":61471,"TIER_GROUP_ID":2,"ROWPOS":3,"LOSE":2,"RANK_SCORE":1240,"WIN":3,"KILL":167},
      {"PARTKEY_SEASON_NO":8,"MODE_NO_DESC":"SND","TIER_GROUP_NAME":"Silver","HEADSHOT":66,"MEDAL":9,"DEATH":25,"RANKING":10,"TIER_STAGE_ID":4,"MODE_NO":2,"MATCH_COUNT":0,"USN":61471,"TIER_GROUP_ID":2,"ROWPOS":4,"LOSE":10,"RANK_SCORE":1172,"WIN":14,"KILL":76}
    ]
}

export const ribbonsPageRewardsData = {
	"dsRibbonTotal": [{
		"ribbonCNT": 7,
		"playerCNT": 0
	}],
	"p_o_ErrID": 1,
	"APImessage": "OK",
	"APIresult": "000",
	"dsRibbonResult": [{
		"tierStart": 0,
		"ribbonDescription": "<p>You have collected 10 or more ribbons.</p>\r\n",
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"itemCode": "C1578",
		"ribbonType": "1",
		"ribbonGroupName": "Status",
		"itemID": "2010162501",
		"achivedDate": null,
		"itemName": "AK47-Blue Crystal (Permanent)",
		"ribbonOption": "20",
		"ROWPOS": 1,
		"imageFileName": "ribbon_0008.jpg",
		"ribbonName": "Look at all my Ribbons",
		"ribbonID": 8,
		"tierEnd": 10,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"tierStart": 11,
		"ribbonDescription": "<p>You have collected 20 or more ribbons.</p>\r\n",
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"itemCode": "C0099",
		"ribbonType": "1",
		"ribbonGroupName": "Status",
		"itemID": "2010010001",
		"achivedDate": null,
		"itemName": "M4A1 Custom Crystal",
		"ribbonOption": "21",
		"ROWPOS": 2,
		"imageFileName": "ribbon_0032.jpg",
		"ribbonName": "My Ribbons are made of Crystals",
		"ribbonID": 32,
		"tierEnd": 20,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"tierStart": 31,
		"ribbonDescription": "<p>You have collected 30 or more ribbons.</p>\r\n",
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"itemCode": "C1579",
		"ribbonType": "1",
		"ribbonGroupName": "Status",
		"itemID": "2010162601",
		"achivedDate": null,
		"itemName": "AWM-Blue Crystal (Permanent)",
		"ribbonOption": "22",
		"ROWPOS": 3,
		"imageFileName": "ribbon_0056.jpg",
		"ribbonName": "I Have More Ribbons Than You",
		"ribbonID": 56,
		"tierEnd": 40,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"tierStart": 41,
		"ribbonDescription": "<p>You have collected 40 or more ribbons.</p>\r\n",
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"itemCode": "C1106",
		"ribbonType": "1",
		"ribbonGroupName": "Status",
		"itemID": "2010115201",
		"achivedDate": null,
		"itemName": "Field shovel Red Dragon 30 days",
		"ribbonOption": "23",
		"ROWPOS": 4,
		"imageFileName": "ribbon_0057.jpg",
		"ribbonName": "My Ribbons Breathe Fire",
		"ribbonID": 57,
		"tierEnd": 50,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"tierStart": 51,
		"ribbonDescription": "<p>You have collected 50 or more Ribbons.</p>\r\n",
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"itemCode": "C1043",
		"ribbonType": "1",
		"ribbonGroupName": "Status",
		"itemID": "2010108801",
		"achivedDate": null,
		"itemName": "Desert Eagle Pink Crystal",
		"ribbonOption": "24",
		"ROWPOS": 5,
		"imageFileName": "ribbon_0083.jpg",
		"ribbonName": "My Ribbons sparkle Pink",
		"ribbonID": 83,
		"tierEnd": 75,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"tierStart": 76,
		"ribbonDescription": "<p>You have collected 75\u00a0or more Ribbons.</p>\r\n",
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons//",
		"itemCode": "C1897",
		"ribbonType": "1",
		"ribbonGroupName": "Status",
		"itemID": "2010194401",
		"achivedDate": null,
		"itemName": "AK-47 Renovo_NoMark",
		"ribbonOption": "25",
		"ROWPOS": 6,
		"imageFileName": "ribbon_0105.jpg",
		"ribbonName": "My Ribbons Are Solid Gold",
		"ribbonID": 105,
		"tierEnd": 100,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"tierStart": 101,
		"ribbonDescription": "<p>You have collected 100 or more Ribbons.</p>\r\n",
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons//",
		"itemCode": "C1899",
		"ribbonType": "1",
		"ribbonGroupName": "Status",
		"itemID": "2010194601",
		"achivedDate": null,
		"itemName": "Gauntlet Dog",
		"ribbonOption": "26",
		"ROWPOS": 7,
		"imageFileName": "ribbon_0106.jpg",
		"ribbonName": "My Ribbons Are Woof Woof",
		"ribbonID": 106,
		"tierEnd": 200,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}],
	"p_o_ErrDesc": null
};


export const ribbonsPageRibbonsData = {
	"dsRibbonTotal": [{
		"ribbonCNT": 97,
		"playerCNT": 3
	}],
	"p_o_ErrID": 1,
	"dsRibbonGroupListResult": [{
		"ribbonGroupInternalDesc": "Account Status (Verified, Premium, Honorable Soldier)",
		"REG_DATE": "2019/08/23 17:10:19.183",
		"ribbonGroupSort": 1,
		"ribbonType": 1,
		"ribbonGroupName": "Status"
	}, {
		"ribbonGroupInternalDesc": "Ribbons Count",
		"REG_DATE": "2019/08/23 17:10:19.183",
		"ribbonGroupSort": 2,
		"ribbonType": 2,
		"ribbonGroupName": "Ribbons Progress"
	}, {
		"ribbonGroupInternalDesc": "Account age (1/2/3/4/5/etc years veteran)",
		"REG_DATE": "2019/08/23 17:10:19.183",
		"ribbonGroupSort": 3,
		"ribbonType": 3,
		"ribbonGroupName": "Years of Service"
	}, {
		"ribbonGroupInternalDesc": "Special manually handed out ribbons (Pro players, content creators, good samaritan)",
		"REG_DATE": "2019/08/23 17:10:19.183",
		"ribbonGroupSort": 4,
		"ribbonType": 4,
		"ribbonGroupName": "Cream of the Crop"
	}, {
		"ribbonGroupInternalDesc": "Inventory Ribbons (, character, Collector, VIP, etc.,)",
		"REG_DATE": "2019/08/23 17:10:19.183",
		"ribbonGroupSort": 5,
		"ribbonType": 5,
		"ribbonGroupName": "Inventory"
	}, {
		"ribbonGroupInternalDesc": "General Stats",
		"REG_DATE": "2019/08/23 17:10:19.183",
		"ribbonGroupSort": 6,
		"ribbonType": 6,
		"ribbonGroupName": "Game Stats"
	}, {
		"ribbonGroupInternalDesc": "Mode Stats",
		"REG_DATE": "2019/08/23 17:10:19.183",
		"ribbonGroupSort": 7,
		"ribbonType": 7,
		"ribbonGroupName": "Mode Stats"
	}, {
		"ribbonGroupInternalDesc": "Clan Ribbons",
		"REG_DATE": "2019/08/23 17:10:19.183",
		"ribbonGroupSort": 8,
		"ribbonType": 8,
		"ribbonGroupName": "Clan"
	}, {
		"ribbonGroupInternalDesc": "Annual Events",
		"REG_DATE": "2019/08/23 17:10:19.183",
		"ribbonGroupSort": 9,
		"ribbonType": 9,
		"ribbonGroupName": "Annual Events"
	}, {
		"ribbonGroupInternalDesc": "Special Events",
		"REG_DATE": "2019/08/23 17:10:19.183",
		"ribbonGroupSort": 10,
		"ribbonType": 10,
		"ribbonGroupName": "Special Events"
	}],
	"APImessage": "OK",
	"APIresult": "000",
	"dsRibbonResult": [{
		"ribbonDescription": "<p>Your Kill/Death Ratio is above 2.0 (Dropping below 2.0 or K/D resets will remove it).</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 60225,
		"achivedDate": "2019/07/08 14:43:48.230",
		"ribbonOption": "31",
		"ROWPOS": 1,
		"imageFileName": "ribbon_0034.jpg",
		"ribbonName": "Clutch Killer",
		"ribbonID": 34,
		"ribbonGroupSort": 1,
		"hasRibbon": 1
	}, {
		"ribbonDescription": "<p>You obtain it when you first create a character.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 60447,
		"achivedDate": "2015/04/14 12:07:51.250",
		"ribbonOption": "1",
		"ROWPOS": 2,
		"imageFileName": "ribbon_0001.jpg",
		"ribbonName": "Creationism",
		"ribbonID": 1,
		"ribbonGroupSort": 1,
		"hasRibbon": 1
	}, {
		"ribbonDescription": "<p>You've never been banned in-game for hacking or similar severe violations (accounts under investigation included).</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 60382,
		"achivedDate": "2015/04/14 12:07:51.250",
		"ribbonOption": "30",
		"ROWPOS": 3,
		"imageFileName": "ribbon_0023.jpg",
		"ribbonName": "Honorable Soldier",
		"ribbonID": 23,
		"ribbonGroupSort": 1,
		"hasRibbon": 1
	}, {
		"ribbonDescription": "<p>Your CrossFire character is older than 9 years.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons//",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 8,
		"achivedDate": null,
		"ribbonOption": "10",
		"ROWPOS": 4,
		"imageFileName": "ribbon_0102.jpg",
		"ribbonName": "9 Year Veteran",
		"ribbonID": 102,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You have either joined the Global Risk or the Black List side for the Rival Factions event. (discontinued)</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 2,
		"ribbonGroupName": "Ribbons Progress",
		"ribbonCount": 7,
		"achivedDate": null,
		"ribbonOption": "100",
		"ROWPOS": 5,
		"imageFileName": "ribbon_0011.jpg",
		"ribbonName": "Which Side are You On",
		"ribbonID": 11,
		"ribbonGroupSort": 2,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You successfully completed the Evolution 2.0 event.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 2,
		"ribbonGroupName": "Ribbons Progress",
		"ribbonCount": 2,
		"achivedDate": null,
		"ribbonOption": "101",
		"ROWPOS": 6,
		"imageFileName": "ribbon_0081.jpg",
		"ribbonName": "CrossFire 2.0",
		"ribbonID": 81,
		"ribbonGroupSort": 2,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You have attended an offline CrossFire event.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons//",
		"ribbonType": 2,
		"ribbonGroupName": "Ribbons Progress",
		"ribbonCount": 1,
		"achivedDate": null,
		"ribbonOption": "102",
		"ROWPOS": 7,
		"imageFileName": "ribbon_0093.jpg",
		"ribbonName": "CrossFire Unplugged",
		"ribbonID": 93,
		"ribbonGroupSort": 2,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You obtain this ribbon by linking your Facebook account through CrossFire's fan page. (discontinued)</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 2,
		"ribbonGroupName": "Ribbons Progress",
		"ribbonCount": 7,
		"achivedDate": null,
		"ribbonOption": "103",
		"ROWPOS": 8,
		"imageFileName": "ribbon_0002.jpg",
		"ribbonName": "FB Friends",
		"ribbonID": 2,
		"ribbonGroupSort": 2,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You earned the rewards during Knife week.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 2,
		"ribbonGroupName": "Ribbons Progress",
		"ribbonCount": 0,
		"achivedDate": null,
		"ribbonOption": "109",
		"ROWPOS": 9,
		"imageFileName": "ribbon_0110.jpg",
		"ribbonName": "Knife Week",
		"ribbonID": 110,
		"ribbonGroupSort": 2,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>Your CrossFire character is older than 10 years.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons//",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 5,
		"achivedDate": null,
		"ribbonOption": "11",
		"ROWPOS": 10,
		"imageFileName": "ribbon_0103.jpg",
		"ribbonName": "10 Year Veteran",
		"ribbonID": 103,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You earned the rewards during Sniper week.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 2,
		"ribbonGroupName": "Ribbons Progress",
		"ribbonCount": 5,
		"achivedDate": null,
		"ribbonOption": "110",
		"ROWPOS": 11,
		"imageFileName": "ribbon_0029.jpg",
		"ribbonName": "Sniper Week",
		"ribbonID": 29,
		"ribbonGroupSort": 2,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You completed any 3 of the Daily events during Handgun Week.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 2,
		"ribbonGroupName": "Ribbons Progress",
		"ribbonCount": 4,
		"achivedDate": null,
		"ribbonOption": "111",
		"ROWPOS": 12,
		"imageFileName": "ribbon_0042.jpg",
		"ribbonName": "Pistol Week",
		"ribbonID": 42,
		"ribbonGroupSort": 2,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You completed all shotgun week challenges.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 2,
		"ribbonGroupName": "Ribbons Progress",
		"ribbonCount": 2,
		"achivedDate": null,
		"ribbonOption": "112",
		"ROWPOS": 13,
		"imageFileName": "ribbon_0071.jpg",
		"ribbonName": "Shotgun Week",
		"ribbonID": 71,
		"ribbonGroupSort": 2,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You've completed all of the daily events and achieved over 1000 zombies kills.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 2,
		"ribbonGroupName": "Ribbons Progress",
		"ribbonCount": 2,
		"achivedDate": null,
		"ribbonOption": "113",
		"ROWPOS": 14,
		"imageFileName": "ribbon_0073.jpg",
		"ribbonName": "Zombie Week",
		"ribbonID": 73,
		"ribbonGroupSort": 2,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You logged in to play CrossFire on Valentine's Day.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 2,
		"ribbonGroupName": "Ribbons Progress",
		"ribbonCount": 4,
		"achivedDate": null,
		"ribbonOption": "120",
		"ROWPOS": 15,
		"imageFileName": "ribbon_0039.jpg",
		"ribbonName": "I <3 CrossFire",
		"ribbonID": 39,
		"ribbonGroupSort": 2,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You've won any permanent weapon from the Black Market on St. Patrick's day during a\u00a0\"Luck of the Irish\" event.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 2,
		"ribbonGroupName": "Ribbons Progress",
		"ribbonCount": 2,
		"achivedDate": null,
		"ribbonOption": "121",
		"ROWPOS": 16,
		"imageFileName": "ribbon_0076.jpg",
		"ribbonName": "Luck of the Irish",
		"ribbonID": 76,
		"ribbonGroupSort": 2,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You participated in the Gold Medal Effort during the Cross Fire Summer Games 2012.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 2,
		"ribbonGroupName": "Ribbons Progress",
		"ribbonCount": 3,
		"achivedDate": null,
		"ribbonOption": "122",
		"ROWPOS": 17,
		"imageFileName": "ribbon_0053.jpg",
		"ribbonName": "CrossFire Summer Games 2012",
		"ribbonID": 53,
		"ribbonGroupSort": 2,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You have completed the CrossFire summer warm-up challenge</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons//",
		"ribbonType": 2,
		"ribbonGroupName": "Ribbons Progress",
		"ribbonCount": 2,
		"achivedDate": null,
		"ribbonOption": "123",
		"ROWPOS": 18,
		"imageFileName": "ribbon_0086.jpg",
		"ribbonName": "Summer Warm-up",
		"ribbonID": 86,
		"ribbonGroupSort": 2,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>Your team have won a gold medal in the CrossFire 2016 Games</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons//",
		"ribbonType": 2,
		"ribbonGroupName": "Ribbons Progress",
		"ribbonCount": 2,
		"achivedDate": null,
		"ribbonOption": "124",
		"ROWPOS": 19,
		"imageFileName": "ribbon_0087.jpg",
		"ribbonName": "CrossFire Games 2016",
		"ribbonID": 87,
		"ribbonGroupSort": 2,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You completed all tasks from the Back 2 School Scavenger Hunt 2014.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 2,
		"ribbonGroupName": "Ribbons Progress",
		"ribbonCount": 2,
		"achivedDate": null,
		"ribbonOption": "125",
		"ROWPOS": 20,
		"imageFileName": "ribbon_0080.jpg",
		"ribbonName": "Back to School Scavenger Hunt",
		"ribbonID": 80,
		"ribbonGroupSort": 2,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You received at least 3 A's on your report card</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons//",
		"ribbonType": 2,
		"ribbonGroupName": "Ribbons Progress",
		"ribbonCount": 1,
		"achivedDate": null,
		"ribbonOption": "126",
		"ROWPOS": 21,
		"imageFileName": "ribbon_0098.jpg",
		"ribbonName": "Grade A Student",
		"ribbonID": 98,
		"ribbonGroupSort": 2,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You have completed all missions in Grave Games</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons//",
		"ribbonType": 2,
		"ribbonGroupName": "Ribbons Progress",
		"ribbonCount": 2,
		"achivedDate": null,
		"ribbonOption": "127",
		"ROWPOS": 22,
		"imageFileName": "ribbon_0099.jpg",
		"ribbonName": "Grave Games",
		"ribbonID": 99,
		"ribbonGroupSort": 2,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You won one of the Christmas items between July 18 - 31st 2013 or July 31 - Aug 13 2014.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 2,
		"ribbonGroupName": "Ribbons Progress",
		"ribbonCount": 2,
		"achivedDate": null,
		"ribbonOption": "128",
		"ROWPOS": 23,
		"imageFileName": "ribbon_0070.jpg",
		"ribbonName": "Christmas in July",
		"ribbonID": 70,
		"ribbonGroupSort": 2,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You logged in the game for the CrossFire Christmas Week from December 24 to 26, 2010, or on December 25, 2011, or on December 25, 2012, or on December 25, 2013. (discontinued)</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 2,
		"ribbonGroupName": "Ribbons Progress",
		"ribbonCount": 4,
		"achivedDate": null,
		"ribbonOption": "129",
		"ROWPOS": 24,
		"imageFileName": "ribbon_0037.jpg",
		"ribbonName": "Merry Christmas",
		"ribbonID": 37,
		"ribbonGroupSort": 2,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You have completed all missions for the 12 Days of Christmas 2016 event</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons//",
		"ribbonType": 2,
		"ribbonGroupName": "Ribbons Progress",
		"ribbonCount": 1,
		"achivedDate": null,
		"ribbonOption": "130",
		"ROWPOS": 25,
		"imageFileName": "ribbon_0089.jpg",
		"ribbonName": "12 Days of Christmas",
		"ribbonID": 89,
		"ribbonGroupSort": 2,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You have the monthly mission and Celebrate the 8 event during March 2017.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna//",
		"ribbonType": 2,
		"ribbonGroupName": "Ribbons Progress",
		"ribbonCount": 2,
		"achivedDate": null,
		"ribbonOption": "140",
		"ROWPOS": 26,
		"imageFileName": "ribbon_0090.jpg",
		"ribbonName": "CrossFire 8th Anniversary",
		"ribbonID": 90,
		"ribbonGroupSort": 2,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>In celebration of CrossFire's 9th Anniversary, and awarded to Players who have successfully completed \"<a href=\"http://forum.z8games.com/showthread.php?335323-The-Whole-9-Yards-March-7-March-15\">The Whole 9 Yards</a>\" Event.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 2,
		"ribbonGroupName": "Ribbons Progress",
		"ribbonCount": 1,
		"achivedDate": null,
		"ribbonOption": "141",
		"ROWPOS": 27,
		"imageFileName": "ribbon_0100.jpg",
		"ribbonName": "9th Anniversary",
		"ribbonID": 100,
		"ribbonGroupSort": 2,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>In celebration of CrossFire's 10th Anniversary, and awarded to Players who have successfully completed the 10th Anniversary\u00a0Events.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons//",
		"ribbonType": 2,
		"ribbonGroupName": "Ribbons Progress",
		"ribbonCount": 1,
		"achivedDate": null,
		"ribbonOption": "142",
		"ROWPOS": 28,
		"imageFileName": "ribbon_0104.jpg",
		"ribbonName": "10th Anniversary",
		"ribbonID": 104,
		"ribbonGroupSort": 2,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You have successfully completed all of the Hero Mode X update weekend events.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 2,
		"ribbonGroupName": "Ribbons Progress",
		"ribbonCount": 5,
		"achivedDate": null,
		"ribbonOption": "150",
		"ROWPOS": 29,
		"imageFileName": "ribbon_0033.jpg",
		"ribbonName": "Exterminator",
		"ribbonID": 33,
		"ribbonGroupSort": 2,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You achieved the daily event tasks during the Hero Mode Patch opening weekend.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 2,
		"ribbonGroupName": "Ribbons Progress",
		"ribbonCount": 4,
		"achivedDate": null,
		"ribbonOption": "151",
		"ROWPOS": 30,
		"imageFileName": "ribbon_0040.jpg",
		"ribbonName": "A Hero Emerges",
		"ribbonID": 40,
		"ribbonGroupSort": 2,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You are an Iron Man! You have played 50+ hours of CrossFire in the month of March 2011.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 2,
		"ribbonGroupName": "Ribbons Progress",
		"ribbonCount": 4,
		"achivedDate": null,
		"ribbonOption": "152",
		"ROWPOS": 31,
		"imageFileName": "ribbon_0041.jpg",
		"ribbonName": "Crossfire Iron Man",
		"ribbonID": 41,
		"ribbonGroupSort": 2,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You have collected at least 5 of the wanted posters during the May 2011 Update.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 2,
		"ribbonGroupName": "Ribbons Progress",
		"ribbonCount": 4,
		"achivedDate": null,
		"ribbonOption": "153",
		"ROWPOS": 32,
		"imageFileName": "ribbon_0043.jpg",
		"ribbonName": "Show Down Sheriff",
		"ribbonID": 43,
		"ribbonGroupSort": 2,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You completed all the event challenges from the Navy SEAL June 2011 Update.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 2,
		"ribbonGroupName": "Ribbons Progress",
		"ribbonCount": 4,
		"achivedDate": null,
		"ribbonOption": "154",
		"ROWPOS": 33,
		"imageFileName": "ribbon_0045.jpg",
		"ribbonName": "Operation Triton",
		"ribbonID": 45,
		"ribbonGroupSort": 2,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You have played 30 or more hours in Ghost Mode during \"March of the Ghost\" in 2012.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 2,
		"ribbonGroupName": "Ribbons Progress",
		"ribbonCount": 3,
		"achivedDate": null,
		"ribbonOption": "155",
		"ROWPOS": 34,
		"imageFileName": "ribbon_0050.jpg",
		"ribbonName": "Silent Soldier",
		"ribbonID": 50,
		"ribbonGroupSort": 2,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You have completed the July 2012 patch events.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 2,
		"ribbonGroupName": "Ribbons Progress",
		"ribbonCount": 4,
		"achivedDate": null,
		"ribbonOption": "156",
		"ROWPOS": 35,
		"imageFileName": "ribbon_0052.jpg",
		"ribbonName": "Conquistador",
		"ribbonID": 52,
		"ribbonGroupSort": 2,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You have contributed 25 or more kills during the 100,000,000 kills challenge.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 2,
		"ribbonGroupName": "Ribbons Progress",
		"ribbonCount": 2,
		"achivedDate": null,
		"ribbonOption": "157",
		"ROWPOS": 36,
		"imageFileName": "ribbon_0060.jpg",
		"ribbonName": "Nightfall",
		"ribbonID": 60,
		"ribbonGroupSort": 2,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You have participated in the November 2012 patch event.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 2,
		"ribbonGroupName": "Ribbons Progress",
		"ribbonCount": 2,
		"achivedDate": null,
		"ribbonOption": "158",
		"ROWPOS": 37,
		"imageFileName": "ribbon_0061.jpg",
		"ribbonName": "Theater of War",
		"ribbonID": 61,
		"ribbonGroupSort": 2,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You have logged in for all 7 days during the Harvest CrossFire 2012 event</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 2,
		"ribbonGroupName": "Ribbons Progress",
		"ribbonCount": 2,
		"achivedDate": null,
		"ribbonOption": "159",
		"ROWPOS": 38,
		"imageFileName": "ribbon_0062.jpg",
		"ribbonName": "Harvest CrossFire",
		"ribbonID": 62,
		"ribbonGroupSort": 2,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You made 1000 kills and play 1000 Minutes in Ghost Mode games in March 2013.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 2,
		"ribbonGroupName": "Ribbons Progress",
		"ribbonCount": 2,
		"achivedDate": null,
		"ribbonOption": "160",
		"ROWPOS": 39,
		"imageFileName": "ribbon_0067.jpg",
		"ribbonName": "Ghost Mode Gauntlet",
		"ribbonID": 67,
		"ribbonGroupSort": 2,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You've completed all of the events during the operation 'May'-hem event.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 2,
		"ribbonGroupName": "Ribbons Progress",
		"ribbonCount": 2,
		"achivedDate": null,
		"ribbonOption": "161",
		"ROWPOS": 40,
		"imageFileName": "ribbon_0068.jpg",
		"ribbonName": "Operation Mayhem",
		"ribbonID": 68,
		"ribbonGroupSort": 2,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You made 5000 kills between May 1-31 during the \"Mayhem Begins\" event in May 2013.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 2,
		"ribbonGroupName": "Ribbons Progress",
		"ribbonCount": 2,
		"achivedDate": null,
		"ribbonOption": "162",
		"ROWPOS": 41,
		"imageFileName": "ribbon_0069.jpg",
		"ribbonName": "The Mayhem Begins",
		"ribbonID": 69,
		"ribbonGroupSort": 2,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You've completed all of the Devastated City events in July 2014.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 2,
		"ribbonGroupName": "Ribbons Progress",
		"ribbonCount": 2,
		"achivedDate": null,
		"ribbonOption": "163",
		"ROWPOS": 42,
		"imageFileName": "ribbon_0078.jpg",
		"ribbonName": "Devastated City",
		"ribbonID": 78,
		"ribbonGroupSort": 2,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You have participated in the community Sheep Mode event in March 2017</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons//",
		"ribbonType": 2,
		"ribbonGroupName": "Ribbons Progress",
		"ribbonCount": 1,
		"achivedDate": null,
		"ribbonOption": "164",
		"ROWPOS": 43,
		"imageFileName": "ribbon_0092.jpg",
		"ribbonName": "Sheep Mayhem",
		"ribbonID": 92,
		"ribbonGroupSort": 2,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You have won a Halloween Costume contest or Halloween Creative event.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 2,
		"ribbonGroupName": "Ribbons Progress",
		"ribbonCount": 3,
		"achivedDate": null,
		"ribbonOption": "165",
		"ROWPOS": 44,
		"imageFileName": "ribbon_0048.jpg",
		"ribbonName": "Halloween Contest",
		"ribbonID": 48,
		"ribbonGroupSort": 2,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You have won a \"best of\" category in the CrossFire Film Awards 2011</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 2,
		"ribbonGroupName": "Ribbons Progress",
		"ribbonCount": 4,
		"achivedDate": null,
		"ribbonOption": "170",
		"ROWPOS": 45,
		"imageFileName": "ribbon_0038.jpg",
		"ribbonName": "CrossFire Film 2011",
		"ribbonID": 38,
		"ribbonGroupSort": 2,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You have been rewarded the \"Best of\" category in CrossFire Film Awards 2012.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 2,
		"ribbonGroupName": "Ribbons Progress",
		"ribbonCount": 3,
		"achivedDate": null,
		"ribbonOption": "171",
		"ROWPOS": 46,
		"imageFileName": "ribbon_0051.jpg",
		"ribbonName": "CrossFire Film 2012",
		"ribbonID": 51,
		"ribbonGroupSort": 2,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You have been rewarded the 'best of' category in Cross Fire Film Festival in 2014.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 2,
		"ribbonGroupName": "Ribbons Progress",
		"ribbonCount": 2,
		"achivedDate": null,
		"ribbonOption": "172",
		"ROWPOS": 47,
		"imageFileName": "ribbon_0077.jpg",
		"ribbonName": "Film Festival",
		"ribbonID": 77,
		"ribbonGroupSort": 2,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>Your CrossFire character is 1 year old.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 60148,
		"achivedDate": null,
		"ribbonOption": "2",
		"ROWPOS": 48,
		"imageFileName": "ribbon_0005.jpg",
		"ribbonName": "Veteran Soldier",
		"ribbonID": 5,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You have collected 10 or more ribbons.</p>\r\n",
		"isTier": 1,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 37,
		"achivedDate": null,
		"ribbonOption": "20",
		"ROWPOS": 49,
		"imageFileName": "ribbon_0008.jpg",
		"ribbonName": "Look at all my Ribbons",
		"ribbonID": 8,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You have collected 20 or more ribbons.</p>\r\n",
		"isTier": 1,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 9,
		"achivedDate": null,
		"ribbonOption": "21",
		"ROWPOS": 50,
		"imageFileName": "ribbon_0032.jpg",
		"ribbonName": "My Ribbons are made of Crystals",
		"ribbonID": 32,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You have collected 30 or more ribbons.</p>\r\n",
		"isTier": 1,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 5,
		"achivedDate": null,
		"ribbonOption": "22",
		"ROWPOS": 51,
		"imageFileName": "ribbon_0056.jpg",
		"ribbonName": "I Have More Ribbons Than You",
		"ribbonID": 56,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You have collected 40 or more ribbons.</p>\r\n",
		"isTier": 1,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 4,
		"achivedDate": null,
		"ribbonOption": "23",
		"ROWPOS": 52,
		"imageFileName": "ribbon_0057.jpg",
		"ribbonName": "My Ribbons Breathe Fire",
		"ribbonID": 57,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You have collected 50 or more Ribbons.</p>\r\n",
		"isTier": 1,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 2,
		"achivedDate": null,
		"ribbonOption": "24",
		"ROWPOS": 53,
		"imageFileName": "ribbon_0083.jpg",
		"ribbonName": "My Ribbons sparkle Pink",
		"ribbonID": 83,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You have collected 75\u00a0or more Ribbons.</p>\r\n",
		"isTier": 1,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons//",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 1,
		"achivedDate": null,
		"ribbonOption": "25",
		"ROWPOS": 54,
		"imageFileName": "ribbon_0105.jpg",
		"ribbonName": "My Ribbons Are Solid Gold",
		"ribbonID": 105,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You have collected 100 or more Ribbons.</p>\r\n",
		"isTier": 1,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons//",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": null,
		"achivedDate": null,
		"ribbonOption": "26",
		"ROWPOS": 55,
		"imageFileName": "ribbon_0106.jpg",
		"ribbonName": "My Ribbons Are Woof Woof",
		"ribbonID": 106,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You are an active and helpful community member</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons//",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 1,
		"achivedDate": null,
		"ribbonOption": "29",
		"ROWPOS": 56,
		"imageFileName": "ribbon_0088.jpg",
		"ribbonName": "Good Samaritan",
		"ribbonID": 88,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You obtain this ribbon when your CrossFire Character is 2 years old.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 60100,
		"achivedDate": null,
		"ribbonOption": "3",
		"ROWPOS": 57,
		"imageFileName": "ribbon_0059.jpg",
		"ribbonName": "Grizzled Veteran",
		"ribbonID": 59,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You have completed 50,000 Games</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons//",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 2,
		"achivedDate": null,
		"ribbonOption": "32",
		"ROWPOS": 58,
		"imageFileName": "ribbon_0095.jpg",
		"ribbonName": "CrossFire is My Reason To Be",
		"ribbonID": 95,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You have played in at least 5,000 matches.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 6,
		"achivedDate": null,
		"ribbonOption": "33",
		"ROWPOS": 59,
		"imageFileName": "ribbon_0022.jpg",
		"ribbonName": "CrossFire is my Life",
		"ribbonID": 22,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You have achieved more than 100,000 kills (resetting your kills does not remove this ribbon once you have achieved it).</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 5,
		"achivedDate": null,
		"ribbonOption": "34",
		"ROWPOS": 60,
		"imageFileName": "ribbon_0035.jpg",
		"ribbonName": "Army of One",
		"ribbonID": 35,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You have achieved 500,000 kills</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons//",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 1,
		"achivedDate": null,
		"ribbonOption": "35",
		"ROWPOS": 61,
		"imageFileName": "ribbon_0096.jpg",
		"ribbonName": "Executioner",
		"ribbonID": 96,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You have received the Elite Grade B or higher in-game badge.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 1,
		"achivedDate": null,
		"ribbonOption": "36",
		"ROWPOS": 62,
		"imageFileName": "ribbon_0006.jpg",
		"ribbonName": "Bow To My Leetness",
		"ribbonID": 6,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You have achieved 5,000 headshots.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 10,
		"achivedDate": null,
		"ribbonOption": "37",
		"ROWPOS": 63,
		"imageFileName": "ribbon_0019.jpg",
		"ribbonName": "You're No Tom Berenger",
		"ribbonID": 19,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>Your CrossFire character is older than 3 years.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons//",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 61,
		"achivedDate": null,
		"ribbonOption": "4",
		"ROWPOS": 64,
		"imageFileName": "ribbon_0063.jpg",
		"ribbonName": "3 Year Veteran",
		"ribbonID": 63,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You are actively completing the Monthly Mixup event!</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons//",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 1,
		"achivedDate": null,
		"ribbonOption": "40",
		"ROWPOS": 65,
		"imageFileName": "ribbon_0094.jpg",
		"ribbonName": "Monthly Mixup",
		"ribbonID": 94,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>Your CrossFire character is older than 4 years.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons//",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 34,
		"achivedDate": null,
		"ribbonOption": "5",
		"ROWPOS": 66,
		"imageFileName": "ribbon_0064.jpg",
		"ribbonName": "4 Year Veteran",
		"ribbonID": 64,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You own 6 different permanent crate guns (includes both GP and ZP crates).</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 59,
		"achivedDate": null,
		"ribbonOption": "50",
		"ROWPOS": 67,
		"imageFileName": "ribbon_0012.jpg",
		"ribbonName": "Crate Buster",
		"ribbonID": 12,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You currently own more than 15 permanent unique (different) weapons. (starting weapons and knife or grenades don't count).</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 49,
		"achivedDate": null,
		"ribbonOption": "51",
		"ROWPOS": 68,
		"imageFileName": "ribbon_0013.jpg",
		"ribbonName": "Gun Hobbyist",
		"ribbonID": 13,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You currently own more than 25 permanent unique (different)\u00a0weapons. (starting weapons and knife or grenades don't count).</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 30,
		"achivedDate": null,
		"ribbonOption": "52",
		"ROWPOS": 69,
		"imageFileName": "ribbon_0014.jpg",
		"ribbonName": "Gun Collector",
		"ribbonID": 14,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You own 3 different pink permanent weapons.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 20,
		"achivedDate": null,
		"ribbonOption": "53",
		"ROWPOS": 70,
		"imageFileName": "ribbon_0066.jpg",
		"ribbonName": "Real Men Wear Pink",
		"ribbonID": 66,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You own 5 permanent and unique HellFire, Flame, Magma or Phoenix weapons.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 3,
		"achivedDate": null,
		"ribbonOption": "54",
		"ROWPOS": 71,
		"imageFileName": "ribbon_0079.jpg",
		"ribbonName": "Arms of Fire",
		"ribbonID": 79,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You own a Thompson, Winchester and the Winchester Scope.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 23,
		"achivedDate": null,
		"ribbonOption": "55",
		"ROWPOS": 72,
		"imageFileName": "ribbon_0020.jpg",
		"ribbonName": "Remember the Good Ole Days",
		"ribbonID": 20,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You own a permanent Christmas weapon.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 40,
		"achivedDate": null,
		"ribbonOption": "56",
		"ROWPOS": 73,
		"imageFileName": "ribbon_0010.jpg",
		"ribbonName": "Christmas Comes but Once a Year",
		"ribbonID": 10,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You own 5 different permanent Shotguns.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 18,
		"achivedDate": null,
		"ribbonOption": "57",
		"ROWPOS": 74,
		"imageFileName": "ribbon_0072.jpg",
		"ribbonName": "Big Game Hunter",
		"ribbonID": 72,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You own the Navy SEALs character with the M14 EBR and the MK.23 Socom.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 4,
		"achivedDate": null,
		"ribbonOption": "58",
		"ROWPOS": 75,
		"imageFileName": "ribbon_0044.jpg",
		"ribbonName": "Seal Team Member",
		"ribbonID": 44,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You own the SPOP character permanently.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 5,
		"achivedDate": null,
		"ribbonOption": "59",
		"ROWPOS": 76,
		"imageFileName": "ribbon_0017.jpg",
		"ribbonName": "Ain't No Party Like an SPOP Party",
		"ribbonID": 17,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>Your CrossFire character is older than 5 years.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 11,
		"achivedDate": null,
		"ribbonOption": "6",
		"ROWPOS": 77,
		"imageFileName": "ribbon_0082.jpg",
		"ribbonName": "5 Year Veteran",
		"ribbonID": 82,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You own all 3 of the basic grenades.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 33,
		"achivedDate": null,
		"ribbonOption": "60",
		"ROWPOS": 78,
		"imageFileName": "ribbon_0009.jpg",
		"ribbonName": "Grenadier",
		"ribbonID": 9,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>Your CrossFire character is older than 6 years.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons//",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 9,
		"achivedDate": null,
		"ribbonOption": "7",
		"ROWPOS": 79,
		"imageFileName": "ribbon_0065.jpg",
		"ribbonName": "6 Year Veteran",
		"ribbonID": 65,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You have earned ZP through a survey.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 7,
		"achivedDate": null,
		"ribbonOption": "70",
		"ROWPOS": 80,
		"imageFileName": "ribbon_0004.jpg",
		"ribbonName": "Survey Says",
		"ribbonID": 4,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You have bought ZP through one of the various deposit options available.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 7,
		"achivedDate": null,
		"ribbonOption": "71",
		"ROWPOS": 81,
		"imageFileName": "ribbon_0003.jpg",
		"ribbonName": "ZP Soldier",
		"ribbonID": 3,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You have gifted ZP or received ZP from another account through prepaid card option.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 5,
		"achivedDate": null,
		"ribbonOption": "72",
		"ROWPOS": 82,
		"imageFileName": "ribbon_0030.jpg",
		"ribbonName": "ZP For Everyone",
		"ribbonID": 30,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You have purchased over 1000 Revive Tokens (tokens from events and promos don't count).</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 4,
		"achivedDate": null,
		"ribbonOption": "73",
		"ROWPOS": 83,
		"imageFileName": "ribbon_0047.jpg",
		"ribbonName": "Revival of the Fittest",
		"ribbonID": 47,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>Your CrossFire character is older than 7 years.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons//",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 12,
		"achivedDate": null,
		"ribbonOption": "8",
		"ROWPOS": 84,
		"imageFileName": "ribbon_0101.jpg",
		"ribbonName": "7 Year Veteran",
		"ribbonID": 101,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You won Search & Destroy Games at least 5,000 times.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons//",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 147,
		"achivedDate": null,
		"ribbonOption": "80",
		"ROWPOS": 85,
		"imageFileName": "ribbon_0109.jpg",
		"ribbonName": "T minus 40",
		"ribbonID": 109,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You have completed 5,000 Ghost Mode Games</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons//",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 1,
		"achivedDate": null,
		"ribbonOption": "81",
		"ROWPOS": 86,
		"imageFileName": "ribbon_0097.jpg",
		"ribbonName": "Sneaky Warrior",
		"ribbonID": 97,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You have killed over 1000 Zombie Mode bosses on normal or higher difficulty.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 1,
		"achivedDate": null,
		"ribbonOption": "84",
		"ROWPOS": 87,
		"imageFileName": "ribbon_0046.jpg",
		"ribbonName": "Like a Bawss",
		"ribbonID": 46,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You have killed the War Monger Zombie Mode boss 100 times on normal difficulty.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 2,
		"achivedDate": null,
		"ribbonOption": "85",
		"ROWPOS": 88,
		"imageFileName": "ribbon_0058.jpg",
		"ribbonName": "War Machine",
		"ribbonID": 58,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You have defended 200 times successfully in ZM2 Normal or Hard mode.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 18,
		"achivedDate": null,
		"ribbonOption": "86",
		"ROWPOS": 89,
		"imageFileName": "ribbon_0108.jpg",
		"ribbonName": "Bulwark",
		"ribbonID": 108,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You reached PVE level 50 in Zombie Mode 3.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons//",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": null,
		"achivedDate": null,
		"ribbonOption": "87",
		"ROWPOS": 90,
		"imageFileName": "ribbon_0116.jpg",
		"ribbonName": "Brain Check",
		"ribbonID": 116,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>Your CrossFire character is older than 8 years.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons//",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 12,
		"achivedDate": null,
		"ribbonOption": "9",
		"ROWPOS": 91,
		"imageFileName": "ribbon_0091.jpg",
		"ribbonName": "8 Year Veteran",
		"ribbonID": 91,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You upgrade any Wave Mode class card to its maximum level (Level 10).</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 3,
		"achivedDate": null,
		"ribbonOption": "90",
		"ROWPOS": 92,
		"imageFileName": "ribbon_0074.jpg",
		"ribbonName": "Head of the Class",
		"ribbonID": 74,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You won 1,000 Wave Mode games.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 2,
		"achivedDate": null,
		"ribbonOption": "91",
		"ROWPOS": 93,
		"imageFileName": "ribbon_0075.jpg",
		"ribbonName": "Tsunami",
		"ribbonID": 75,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You have played in 100 Hero Mode X games where the soldiers side has won.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 3,
		"achivedDate": null,
		"ribbonOption": "92",
		"ROWPOS": 94,
		"imageFileName": "ribbon_0049.jpg",
		"ribbonName": "Xenophobe",
		"ribbonID": 49,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You have played in 100 Hero Mode X games where the mutants side has won.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 5,
		"achivedDate": null,
		"ribbonOption": "93",
		"ROWPOS": 95,
		"imageFileName": "ribbon_0036.jpg",
		"ribbonName": "Lead the Invasion",
		"ribbonID": 36,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You have survived 4+ rounds or more in 250 different clan matches.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 3,
		"achivedDate": null,
		"ribbonOption": "95",
		"ROWPOS": 96,
		"imageFileName": "ribbon_0054.jpg",
		"ribbonName": "Clan Survivalist",
		"ribbonID": 54,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}, {
		"ribbonDescription": "<p>You have killed at least 10 or more soldiers in 250 different clan matches.</p>\r\n",
		"isTier": 0,
		"imagePath": "https://z8games.akamaized.net/cfna/templates/assets/imgs/ribbons/",
		"ribbonType": 1,
		"ribbonGroupName": "Status",
		"ribbonCount": 3,
		"achivedDate": null,
		"ribbonOption": "96",
		"ROWPOS": 97,
		"imageFileName": "ribbon_0055.jpg",
		"ribbonName": "Credit to the Clan",
		"ribbonID": 55,
		"ribbonGroupSort": 1,
		"hasRibbon": 0
	}],
	"p_o_ErrDesc": null
};